module.exports = __webpack_public_path__ + "img/interactive-hero-slider-ford.075089f7.png";